import React, { useEffect, useState } from "react";
import { IconUsers, IconUserCheck, IconTrophy } from "@tabler/icons-react";
import { driver } from "driver.js";
import "driver.js/dist/driver.css";
import { dashboardSteps } from "../utils/tutorial";
import { IconHelp } from "@tabler/icons-react";
import Loader from "./Loader";
import conocedorImg from "../images/conocedor.png";
import espectadorImg from "../images/espectador.png";
import exploradorImg from "../images/explorador.png";
import promotorImg from "../images/promotor.png";
import Histograma from "./Histograma";
import ModalSimV2 from "./ModalSimV2";

//const IP = "http://localhost:5020";
const IP = "https://reportes.aux-rolplay.com";

const Dashboard = () => {
  const [metrics, setMetrics] = useState(null);
  const [categories, setCategories] = useState(null);
  const [totalLogin, setTotalLogin] = useState(null);
  const [totalUsers, setTotalUsers] = useState(null);
  const [totalLoginUnicos, setTotalLoginUnicos] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isExiting, setIsExiting] = useState(false);
  const [showHistogram, setShowHistogram] = useState(false);
  const [showSimV2Modal, setShowSimV2Modal] = useState(false);

  useEffect(() => {
    Promise.all([
      fetch(`${IP}/salinas/metricas`).then((response) => response.json()),
      fetch(`${IP}/salinas/categorias`).then((response) => response.json()),
      fetch(`${IP}/salinas/totallogin`).then((response) => response.json()),
      fetch(`${IP}/salinas/totalusers`).then((response) => response.json()),
      fetch(`${IP}/salinas/totalloginunicos`).then((response) =>
        response.json(),
      ),
    ])
      .then(
        ([
          metricsData,
          categoriesData,
          loginData,
          usersData,
          loginUnicosData,
        ]) => {
          setMetrics(metricsData);
          setCategories(categoriesData);
          setTotalLogin(loginData);
          setTotalUsers(usersData);
          setTotalLoginUnicos(loginUnicosData);
          setIsExiting(true);
          setTimeout(() => {
            setIsLoading(false);
          }, 500);
        },
      )
      .catch((error) => {
        console.error("Error:", error);
        setIsExiting(true);
        setTimeout(() => {
          setIsLoading(false);
        }, 500);
      });
  }, []);

  const startTutorial = () => {
    const driverObj = driver({
      showProgress: true,
      steps: dashboardSteps,
      animate: true,
      overlayColor: "#00000099",
    });
    driverObj.drive();
  };

  if (isLoading) {
    return <Loader isExiting={isExiting} />;
  }

  return (
    <div className="w-full max-w-7xl mx-auto p-6">
      <div className="bg-white rounded-2xl shadow-lg p-8">
        <div className="flex items-center justify-between mb-8">
          <h1 className="text-2xl font-bold text-gray-900">
            Panel de Métricas
          </h1>
          <div className="flex items-center gap-4">
            <button
              onClick={startTutorial}
              className="px-6 py-2.5 bg-[#FB9405] hover:bg-[#e08404] rounded-full text-sm font-medium text-white shadow-md hover:shadow-xl transition-all duration-300 flex items-center gap-2"
              title="Iniciar Tutorial"
            >
              <IconHelp size={18} />
              Tutorial
            </button>
            <div className="px-4 py-2 bg-gradient-to-r from-purple-50 to-purple-100 rounded-full border border-purple-300">
              <p className="text-sm text-purple-700 font-medium">
                Auto-actualización backend: 30 min | ↻ Manual si requiere datos
                mas recientes
              </p>
            </div>
          </div>
        </div>

        {/* Métricas Principales */}
        <div
          id="dashboard-metrics"
          className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-8"
        >
          <div className="bg-gradient-to-br from-red-600 to-red-700 rounded-2xl p-6 border border-red-400 hover:shadow-lg transition-shadow">
            <div className="relative">
              <IconUsers className="text-white/90 mb-4" size={28} />
              <p className="text-white/80 text-sm font-medium mb-1">
                Total Usuarios (Flujo completado)
              </p>
              <div className="flex items-baseline gap-2 mb-3">
                <h3 className="text-3xl font-bold text-white">
                  {metrics?.cantidad_usuarios || 0}
                </h3>
                <span className="text-sm font-medium text-white/70">
                  ({metrics?.porcentaje_usuarios || 0}%)
                </span>
              </div>
              <div className="w-full h-2 bg-red-800/30 rounded-full overflow-hidden">
                <div
                  className="h-full bg-white"
                  style={{ width: `${metrics?.porcentaje_usuarios || 0}%` }}
                />
              </div>
            </div>
          </div>

          <div className="bg-gradient-to-br from-red-600 to-red-700 rounded-2xl p-6 border border-red-400 hover:shadow-lg transition-shadow">
            <div className="relative">
              <IconUserCheck className="text-white/90 mb-4" size={28} />
              <p className="text-white/80 text-sm font-medium mb-1">
                Total Usuarios (Base de datos)
              </p>
              <div className="flex items-baseline gap-2">
                <h3 className="text-3xl font-bold text-white">
                  {totalUsers?.total_users || 0}
                </h3>
              </div>
            </div>
          </div>

          <div className="bg-gradient-to-br from-red-600 to-red-700 rounded-2xl p-6 border border-red-400 hover:shadow-lg transition-shadow">
            <div className="relative">
              <IconUsers className="text-white/90 mb-4" size={28} />
              <p className="text-white/80 text-sm font-medium mb-1">
                Total Eventos Login
              </p>
              <div className="flex items-baseline gap-2">
                <h3 className="text-3xl font-bold text-white">
                  {totalLogin?.total_login || 0}
                </h3>
              </div>
            </div>
          </div>

          <div className="bg-gradient-to-br from-red-600 to-red-700 rounded-2xl p-6 border border-red-400 hover:shadow-lg transition-shadow">
            <div className="relative">
              <IconUsers className="text-white/90 mb-4" size={28} />
              <p className="text-white/80 text-sm font-medium mb-1">
                Total Usuarios Login Únicos
              </p>
              <div className="flex items-baseline gap-2">
                <h3 className="text-3xl font-bold text-white">
                  {totalLoginUnicos?.total_login_unicos || 0}
                </h3>
              </div>
            </div>
          </div>
        </div>

        {/* Categorías */}
        <div id="dashboard-categories" className="bg-gray-50 rounded-2xl p-8">
          <div className="flex items-center justify-between mb-6">
            <div className="flex items-center gap-3">
              <IconTrophy className="text-red-500" size={24} />
              <h2 className="text-xl font-semibold text-gray-900">
                Distribución de Categorías
              </h2>
            </div>
            <div className="flex items-center gap-2">
              <div className="px-4 py-2 bg-gradient-to-r from-purple-50 to-purple-100 rounded-full border border-purple-300">
                <p className="text-sm text-purple-700 font-medium">
                  Datos basados en usuarios (Flujo completado) Sim V2
                </p>
              </div>
              <button
                onClick={() => setShowSimV2Modal(true)}
                className="px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg transition-colors duration-200"
              >
                Tabla Sim V2
              </button>
              <button
                onClick={() => setShowHistogram(true)}
                className="px-4 py-2 bg-purple-600 hover:bg-purple-700 text-white rounded-lg transition-colors duration-200"
              >
                Histogramas
              </button>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {[
              {
                title: "Espectador",
                count: categories?.cantidad_usuarios_Espectador || 0,
                percent: categories?.porcentaje_usuarios_Espectador || 0,
                image: espectadorImg,
              },
              {
                title: "Explorador",
                count: categories?.cantidad_usuarios_Explorador || 0,
                percent: categories?.porcentaje_usuarios_Explorador || 0,
                image: exploradorImg,
              },
              {
                title: "Conocedor",
                count: categories?.cantidad_usuarios_Conocedor || 0,
                percent: categories?.porcentaje_usuarios_Conocedor || 0,
                image: conocedorImg,
              },
              {
                title: "Promotor",
                count: categories?.cantidad_usuarios_Protagonista || 0,
                percent: categories?.porcentaje_usuarios_Protagonista || 0,
                image: promotorImg,
              },
            ].map((category) => (
              <div
                key={category.title}
                className="bg-white rounded-xl p-6 border border-gray-200 hover:shadow-lg transition-shadow"
              >
                <div className="flex items-center gap-4 mb-4">
                  <img
                    src={category.image}
                    alt={category.title}
                    className="w-12 h-12 rounded-full object-cover border-2 border-red-500"
                  />
                  <span className="text-lg font-semibold text-gray-900">
                    {category.title}
                  </span>
                </div>
                <div className="space-y-3">
                  <p className="text-3xl font-bold text-gray-900">
                    {category.count}
                  </p>
                  <div className="space-y-2">
                    <div className="w-full h-3 bg-gray-100 rounded-full overflow-hidden">
                      <div
                        className="h-full bg-gradient-to-r from-red-500 to-red-600"
                        style={{ width: `${category.percent}%` }}
                      />
                    </div>
                    <div className="flex justify-between items-center text-sm">
                      <span className="text-gray-600 font-medium">
                        Porcentaje referente al total de usuario (Flujo
                        completado)
                      </span>
                      <span className="font-semibold text-gray-800">
                        {category.percent.toFixed(2)}%
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <Histograma
        isOpen={showHistogram}
        onClose={() => setShowHistogram(false)}
      />
      <ModalSimV2
        isOpen={showSimV2Modal}
        onClose={() => setShowSimV2Modal(false)}
      />
    </div>
  );
};

export default Dashboard;
